import { render, staticRenderFns } from "./cardlist.vue?vue&type=template&id=6127d64e"
import script from "./cardlist.vue?vue&type=script&lang=js"
export * from "./cardlist.vue?vue&type=script&lang=js"
import style0 from "./cardlist.vue?vue&type=style&index=0&id=6127d64e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports